import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCgKyVRGtSHBdV3miRX8opb5Q6-wVUt6no",
    authDomain: "tinder-clone-98698.firebaseapp.com",
    databaseURL: "https://tinder-clone-98698.firebaseio.com",
    projectId: "tinder-clone-98698",
    storageBucket: "tinder-clone-98698.appspot.com",
    messagingSenderId: "801734171985",
    appId: "1:801734171985:web:9157fba02c126cbe8bc770",
    measurementId: "G-1DBZ0DQ6QB"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const database = firebaseApp.firestore();

export default database;